import { render } from "./PopupModalPage.vue?vue&type=template&id=4e211a63"
import script from "./PopupModalPage.vue?vue&type=script&lang=js"
export * from "./PopupModalPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/G23/web-portal/bia-webportal-prod/bia-cms-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__